import { graphql, useStaticQuery } from 'gatsby'
import { useCallback, useMemo } from 'react'

const useCampaigns = ({ campaignIds = [] } = {}) => {
  const data = useStaticQuery(graphql`
    query {
      allCampaign(filter: { id: { ne: "placeholder" } }) {
        nodes {
          id
          description
          name
          applications {
            id
            slug
            name
            installations
            shortDescription
            product
            logo {
              ...ProductLogo
            }
            category {
              id
              name
              slug
            }
            icons {
              id
              large
              original
              small
              title
            }
            payment {
              frequency
              price
            }
            customProps {
              appVideoUrl
              hiddenForBeta
              isService
              usingBeta
            }
            hidden
            underMaintenance
            longDescription
            tutorialUrl
          }
          attributes {
            tags
          }
          image {
            childImageSharp {
              gatsbyImageData(
                quality: 70
                transformOptions: { fit: CONTAIN }
                layout: FULL_WIDTH
                placeholder: NONE
              )
            }
          }
          logo {
            childImageSharp {
              gatsbyImageData(
                height: 40
                transformOptions: { fit: CONTAIN }
                placeholder: NONE
                backgroundColor: "transparent"
              )
            }
          }
          properties {
            background
            logo
            image
            image2x
            image3x
            promoHeading
            copyHeading
            copyDescription
            buttonCopy
            buttonRoute
          }
        }
      }
    }
  `)

  const allCampaigns = data.allCampaign.nodes

  const findCampaign = useCallback(
    (campaignId) =>
      allCampaigns.find(({ id }) => id === String(campaignId).trim()),
    [allCampaigns]
  )

  const campaigns = useMemo(
    () => campaignIds.map(findCampaign).filter(Boolean),
    [campaignIds, findCampaign]
  )

  return {
    apps: [],
    campaigns,
    allCampaigns,
    findCampaign,
  }
}

export default useCampaigns
